<template>
  <div class="invoice-list-box">
    <a-radio-group
      v-model="current"
      class="list-tab"
      @change="getCurrentDatas"
    >
      <a-radio-button value="1">
        {{ $t('message["140"]') }}
      </a-radio-button>
      <a-radio-button value="0">
        {{ $t('message["1465"]') }}
      </a-radio-button>
    </a-radio-group>
    <div class="order-invoice-list">
      <template v-if="current * 1 ===1 ">
        <order-list />
      </template>
      <template v-else>
        <invoice-list />
      </template>
    </div>
  </div>
</template>
<script>
import OrderList from './invoice/OrderList'
import InvoiceList from './invoice/InvoiceList'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
  components: {
    OrderList,
    InvoiceList
  },
  computed: {
    ...mapState('account/invoice', {
      storeCurrent: 'current'
    }),
    ...mapState('account/invoice', ['datas', 'current']),
    current: {
      get () {
        return this.storeCurrent
      },
      set (value) {
        return this.setCurrentIndex(value)
      }
    }
  },
  async mounted () {
    if (this.current * 1) {
      const chain = await this.fetchOrderListDatas()
      chain.params({ isinvoice: 0 })
        .fetch()
      const chain2 = await this.fetchInvoiceMoneyDatas()
      chain2.fetch()
    } else {
      const chain = await this.fetchInvoiceListDatas()
      chain.fetch()
    }
  },
  methods: {
    ...mapActions('account/invoice', ['fetchOrderListDatas', 'fetchInvoiceListDatas', 'fetchInvoiceMoneyDatas']),
    ...mapMutations('account/invoice', ['setCurrentIndex']),
    async getCurrentDatas (e) {
      const tab = e.target.value * 1
      if (tab) {
        const chain = await this.fetchOrderListDatas()
        chain.params({ isinvoice: 0 })
          .fetch()
      } else {
        const chain = await this.fetchInvoiceListDatas()
        chain.fetch()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-list-box {
  padding-top: 10px;
}
.order-invoice-list {
  padding: 16px 0 24px;
}
</style>
